import {IRegPointer, REG} from "lib/commons/registry";
import {Action, IAction} from "lib/commons/actions";
import {IDepotResUiEnv} from "lib/store/depot";
import {POPUP, PopupFloating} from "back/commons/widgets/popups";
import {DownloadRes, EditMetasRes, EditPermsRes, ImportRes, MoveRes, OpenViewRes, RemoveRes, RenameRes, VisStateRes} from "back/store/actions/resActions";
import {IDepotResCtx, IDepotShortResCtx} from "lib/store/res";
import "back/store/widgets/resGrid";

//Actions et skins ResMainArea.

/**
 * Actions d'édition
 */
function addEditAction(action: IAction<IDepotShortResCtx | IDepotResCtx>) {
	REG.reg.addToList("actions:depot:resMainView:edit", action.getId(), 1, action);
}

addEditAction(new ImportRes());
addEditAction(new EditMetasRes());
addEditAction(new EditPermsRes());
addEditAction(new MoveRes());
addEditAction(new RenameRes());
addEditAction(new VisStateRes());
addEditAction(new RemoveRes());


//cf trashUnlistActions.tsx#switchVisState2TrashUnlistActions(REG.reg, "actions:depot:resMainView:edit")

/**
 * Actions de visu d'infos
 */
function addInfoAction(action: IAction<IDepotShortResCtx | IDepotResCtx>) {
	REG.reg.addToList("actions:depot:resMainView:infos", action.getId(), 1, action);
}

addInfoAction(new OpenViewRes());

addInfoAction(new Action<IRegPointer<IDepotResUiEnv>>("infoDetails")
	.setIcon("/@skin@/store/views/resViews/info.svg")
	.setLabel("Informations détaillées")
	.setExecute(async (ctx: IRegPointer<IDepotResUiEnv>, ev?: Event) => {
		const infoArea = ctx.reg.env.resType.resView("infos");
		const from = ev.target as HTMLElement;
		const ct = await infoArea.loadBody(ctx);
		if (ct.shadowRoot) ctx.reg.installSkin('webzone:page', ct.shadowRoot);
		if (!from.isConnected) return; //racecond
		POPUP.showFloating((popup: PopupFloating) => {
			return ct;
		}, from, from, {closeOnBlur: true});
	})
);

addInfoAction(new DownloadRes(null, null).setVisible((ctx) => {if (ctx.reg.env.resType.prcIsFolder) return false}));

/**
 * Skin de la vue principale d'une ressource.
 */
REG.reg.registerSkin("store-res-main", 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	[hidden] {
		display: none;
	}

	header {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: row;
		padding: .7em;
		border-bottom: 1px solid var(--border-color);
	}

	store-res-anc {
		flex: 1;
	}

	#resEdit {
		flex-wrap: wrap;
		justify-content: flex-end;
	}

	main {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		max-width: 60em;
		box-sizing: border-box;
		width: 100%;
		padding: 1em 1em 0;
		align-self: center;
	}

	store-res-infos {
		margin-bottom: 1em;
	}

	store-res-infos:last-child {
		border-bottom: 1px solid var(--border-color);
	}
`);

/** Style pour le header de la mainView */
REG.reg.registerSkin("store-res-titlebar", 1, /* language=CSS */ `
	:host {
		flex-shrink: 0;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		padding: 0 .5em;
	}

	#title, #version {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: row;
		align-items: center;
		margin-bottom: 1em;
	}

	.label {
		font-variant: all-small-caps;
		color: var(--fade-color);
	}

	.icon {
		filter: var(--filter);
		height: 2em;
	}


	#nameCtn {
		flex: 1;
		margin: 0 .5em;
	  font-size: 1.6em;
	}

	.name {
		font-weight: bold;
	}

	.unlisted {
		background: no-repeat right .2em top .2em / .5em url(/@skin@/store/states/limited.svg);
		padding-inline-end: 1em;
	}

	.trashed {
		background: no-repeat right .2em top .2em / .5em url(/@skin@/store/states/invisible.svg);
		padding-inline-end: 1em;
	}


  #version > store-res-versions {
	  flex: 1;
	  background-color: var(--alt1-bgcolor);
	  background-position: right .3em center;
	  border-radius: .4em;
	  font-weight: bold;
	  margin-inline-end: .5em;
	  justify-content: start;
	  opacity: 1 !important;
	  padding: .3em .5em;
  }

  #versionInTi {
	  padding-inline-start: .3em;
	  color: var(--alt1-color);
  }
  
  #versionInTi > store-res-versions {
	  display: inline;
	  font-size: 1em;
	  padding-inline-start: 1.1em;
	  padding-inline-end: 0;
	  background: var(--dropdown-url) no-repeat left / 1em;
  }
`);